<div class="toast" [class]="'toast--' + position()" aria-live="assertive" aria-atomic="true">
  @if (message(); as currentMessage) {
    <div class="toast__message" [class]="'toast__message--' + currentMessage.severity" role="alert">
      <i class="toast__icon" [class]="iconClass()" aria-hidden="true"></i>
      <div class="toast__text">
        <p class="toast__summary">{{ currentMessage.summary }}</p>
        @if (currentMessage.detail) {
          <p class="toast__detail">{{ currentMessage.detail }}</p>
        }
      </div>
      <button type="button" class="toast__close" aria-label="Close" (click)="dismiss()">
        <i class="ph ph-x" aria-hidden="true"></i>
      </button>
    </div>
  }
</div>
